export const SET_FACET_CONSTANTS = 'Set facet constants';
export const REPORT_ERROR = 'Report error';
export const CLEAR_ERROR = 'Clear error';
export const SET_SEARCH_TERM = 'Set search term';
export const CHANGE_LANG = 'Change language';
export const SET_SEARCH_STATE = 'Set search state';
export const SET_DOCGROUP_STATE = 'Set docGroup state';
export const SET_SEARCH_FORM_FULL_SCREEN = 'Set full screen';
export const SET_SEARCH_SUBMITED = 'Set search submited';
